/* eslint-disable */
import $ from 'jquery';

(function($, window, document, undefined){
  var defaults = {};

  var Limiter = function(element, options){
    this._el = element;
    this.$el = $(this._el);
    this.$el.addClass('limiter--enabled');
    this.$elChildren = this.$el.children();
    this.state = 'closed';

    this._options = options;
    this.options = $.extend({}, defaults, this._options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.init();
  };

  $.extend(Limiter.prototype, {
    init: function(){
      this.bindEvents();
    },
    calculateRows: function(){
      var intLastOffset = this.$elChildren.first().offset().top;
      var intCurrentRow = 0;
      var arrRows = [];
      this.$elChildren.show();
      this.$elChildren.each(function(){
        var $el = $(this);
        var intCurrentOffset = $el.offset().top;

        if (intCurrentOffset === intLastOffset) {
          if (!$.isArray(arrRows[intCurrentRow])) {
            arrRows[intCurrentRow] = [];
          }
          arrRows[intCurrentRow].push($el);
        } else {
          intLastOffset = intCurrentOffset;
          ++intCurrentRow;
          arrRows.push([$el]);
        }
      });
      this.arrRows = arrRows;
    },
    hideRows: function(){
      this.$elChildren.hide();
      var arrVisibleRows = this.arrRows.slice(0, this.options.limitRows);
      for (var row in arrVisibleRows) {
        for (var child in arrVisibleRows[row]) {
          $(arrVisibleRows[row][child]).show();
        }
      }
      this.state = 'closed';
    },
    bindEvents: function(){
      $(window).on('resize.Limiter', $.proxy(this.onResize, this)).trigger('resize.Limiter');
      this.$el.next('.btn').on('click.Limiter', $.proxy(this.toggleRows, this));
    },
    onResize: function(){
      this.calculateRows();
      if (this.state === 'closed') this.hideRows();
      this.$el.next('.btn').toggle(this.arrRows.length > this.options.limitRows);
    },
    showRows: function(){
      this.$elChildren.show();
      this.state = 'opened';
    },
    toggleRows: function(event){
      var $el = $(event.delegateTarget);
      event.preventDefault();
      if (this.state === 'opened') {
        this.hideRows();
        $el.find('.btn__text').text(this.options.buttonTextOpen);
        $('html, body').animate({
          'scrollTop': this.$el.offset().top - $('.page-header').height() - 25
        }, 500);
      } else if (this.state === 'closed') {
        this.showRows();
        $el.find('.btn__text').text(this.options.buttonTextClose);
      }
      $el.toggleClass('is--toggled');
    }
  });

  $.fn.Limiter = function(options){
    return this.each(function(){
      var returnValue = null;
      if (!$.data(this, 'Limiter')) {
        returnValue = $.data(this, 'Limiter', new Limiter(this, options));
      } else {
        returnValue = $.data(this, 'Limiter');
      }
      return returnValue;
    });
  };

  $('[data-limit-rows]').Limiter();
})($, window, document);



// WEBPACK FOOTER //
// ./assets/js/components/limiter.js